const AssignInitiatorToLeadPartyRequest = function() {
  return {
    dropAssignee: false
  };
};

export default AssignInitiatorToLeadPartyRequest;



// WEBPACK FOOTER //
// ./src/service/request/AssignInitiatorToLeadPartyRequest.js